import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_have_a_written_strategy_goals_documents_for_social'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_have_a_written_strategy_goals_documents_for_social',
  name: 'Does the facility have a written strategy / goals document(s) for social and labor practices addressing the following points?',
  description:
    'The intent of this question is to understand if the facility has an OVERALL written strategy in place.\r\r\n\r\r\nEven though this strategy question is coming after the policies and procedures questions in this tool, in many cases written strategies are established first.\r\r\n\r\r\nMeaning, a facility might create written strategy for their overall goals in terms of social & labor outcomes and then draft policies and procedures based on the strategies or goals it is trying to meet.',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'REFERENCE_TO_OVERALL_GOALS_IN_TERMS_OF_SOCIAL_AND_LABOR_OUTCOME',
      text: 'Reference to overall goals in terms of social and labor outcomes',
      externalIds: [
        {
          id: 'ms-2-1x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'PLEASE_PROVIDE_THE_NAME_OF_DOCUMENT_S_REFERENCING_OVERALL_GOALS',
      text: 'Please provide the name of document(s) referencing overall goals in terms of social and labor outcomes:',
      externalIds: [
        {
          id: 'ms-2-1f',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'REFERENCE_TO_NATIONAL_LAW',
      text: 'Reference to national law',
      externalIds: [
        {
          id: 'ms-2-2x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'REFERENCE_TO_INTERNATIONAL_LAW_ILO_CONVENTIONS',
      text: 'Reference to international law/ILO conventions',
      externalIds: [
        {
          id: 'ms-2-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'REFERENCE_TO_OTHER_NATIONAL_OR_INTERNATIONAL_REQUIREMENTS_DECLA',
      text: 'Reference to other national or international requirements/declarations/goals/guiding principles etc.',
      externalIds: [
        {
          id: 'ms-2-4x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'REFERENCE_TO_A_RISK_ASSESSMENT_PROCESS_SPECIFICALLY_A_STRATEGY_',
      text: 'Reference to a risk assessment process, specifically a strategy for responsible sourcing from high-risk suppliers or high-risk raw material origins',
      externalIds: [
        {
          id: 'ms-2-5x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'REFERENCE_TO_INTEGRATION_WITH_BUSINESS_OBJECTIVES',
      text: 'Reference to integration with business objectives',
      externalIds: [
        {
          id: 'ms-2-6x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'REFERENCE_TO_SUPPLIERS_SUBCONTRACTORS_SOCIAL_AND_LABOR_DUE_DILI',
      text: 'Reference to suppliers/subcontractors social and labor due diligence',
      externalIds: [
        {
          id: 'ms-2-7x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'REFERENCE_TO_GENDER_EQUALITY_AND_WOMEN_S_EMPOWERMENT',
      text: "Reference to gender equality and women's empowerment",
      externalIds: [
        {
          id: 'ms-pla-57x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'KEY_STAKEHOLDERS_ARE_INVOLVED_IN_STRATEGY_DEVELOPMENT_I_E_CUSTO',
      text: 'Key stakeholders are involved in strategy development (i.e. customers, etc.)',
      externalIds: [
        {
          id: 'ms-2-8x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'PLEASE_DESCRIBE_THE_KEY_STAKEHOLDERS_INVOLVED_',
      text: 'Please describe the key stakeholders involved:',
      externalIds: [
        {
          id: 'ms-2-8f',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NO_WRITTEN_STRATEGY_GOALS_DOCUMENT_EXISTS_BUT_INFORMAL_STRATEGI',
      text: 'No written strategy/goals document exists (but informal strategies/goals may exist)',
      externalIds: [
        {
          id: 'ms-2-9x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'REFERENCE_TO_OVERALL_GOALS_IN_TERMS_OF_SOCIAL_AND_LABOR_OUTCOME',
                'PLEASE_PROVIDE_THE_NAME_OF_DOCUMENT_S_REFERENCING_OVERALL_GOALS',
                'REFERENCE_TO_NATIONAL_LAW',
                'REFERENCE_TO_INTERNATIONAL_LAW_ILO_CONVENTIONS',
                'REFERENCE_TO_OTHER_NATIONAL_OR_INTERNATIONAL_REQUIREMENTS_DECLA',
                'REFERENCE_TO_A_RISK_ASSESSMENT_PROCESS_SPECIFICALLY_A_STRATEGY_',
                'REFERENCE_TO_INTEGRATION_WITH_BUSINESS_OBJECTIVES',
                'REFERENCE_TO_SUPPLIERS_SUBCONTRACTORS_SOCIAL_AND_LABOR_DUE_DILI',
                'REFERENCE_TO_GENDER_EQUALITY_AND_WOMEN_S_EMPOWERMENT',
                'KEY_STAKEHOLDERS_ARE_INVOLVED_IN_STRATEGY_DEVELOPMENT_I_E_CUSTO',
                'PLEASE_DESCRIBE_THE_KEY_STAKEHOLDERS_INVOLVED_',
                'NO_WRITTEN_STRATEGY_GOALS_DOCUMENT_EXISTS_BUT_INFORMAL_STRATEGI',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ms-pla-56',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 20540,
  sectionId: '2.2.6.12',
  impactArea: 'Management Systems',
  impactAreaId: 'MANAGEMENT_SYSTEMS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
